import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "ui/components/dialog";
import { FormField, FormItem, FormMessage } from "ui/components/form";
import { Input } from "ui/components/input";
import { Form } from "react-crud-form";
import { FormLabel } from "components/form";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { casestudySchema } from "./schema";
import React from "react";
import { useNavigate } from "react-router-dom";
import { FormActions } from "components/form/actions";
import { useCreateCasestudy } from "../create/mutation";
import ProjectCombobox from "components/directus/combobox/project";
import { useSelector } from "react-redux";
import { selectUser } from "store/src/slices/auth-slice";

export default function CreateCaseStudyDialog({ open, onOpenChange }) {
  const navigate = useNavigate();
  const createCasestudyMutation = useCreateCasestudy();
  const { id } = useSelector(selectUser);

  const form = useForm({
    resolver: zodResolver(casestudySchema),
    defaultValues: {
      name: "",
      project: "",
    },
  });

  async function handleCreate(context) {
    const values = context.values;
    const response = await createCasestudyMutation.mutateAsync({
      values,
    });
    onOpenChange(false);
    navigate(`/case-studies/${response.id}/edit`);
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Create Case Study</DialogTitle>
        </DialogHeader>
        <Form
          form={form}
          create={handleCreate}
          itemId="+"
          schema={casestudySchema}
        >
          {({ isCreating, createItem, isDirty, isNewItem }) => (
            <div className="grid gap-4">
              <FormField
                control={form.control}
                name="name"
                render={({ field }) => {
                  return (
                    <FormItem>
                      <FormLabel>Name</FormLabel>
                      <Input {...field} />
                      <FormMessage />
                    </FormItem>
                  );
                }}
              />

              <FormField
                control={form.control}
                name="project"
                render={({ field }) => (
                  <FormItem>
                    <ProjectCombobox
                      value={field.value}
                      className="w-full"
                      placeholder="Select"
                      searchPlaceholder="Search Project..."
                      onChange={(selectedItem) => field.onChange(selectedItem)}
                    />
                    <FormMessage />
                  </FormItem>
                )}
              />

              <FormActions
                isNewItem={isNewItem}
                isCreating={isCreating}
                isDirty={isDirty}
                createItem={createItem}
                onCancel={onOpenChange}
                teleport={false}
                className="justify-end"
              />
            </div>
          )}
        </Form>
      </DialogContent>
    </Dialog>
  );
}
